import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_API_HOST + '/last-analytics-update';

const LastUpdated = () => {
  const [data, setData] = useState({ last_update: '', human: '' });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUpdate = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(API_URL);
      if (!response.ok) throw new Error('Error fetching last update');
      const json = await response.json();
      setData(json);
    } catch (err) {
      setError('No se pudo obtener la última actualización');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUpdate();
    const interval = setInterval(fetchUpdate, 5 * 60 * 1000); // 5 minutos
    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: '4px' }}>
      {loading ? (
        <Typography variant="body2" color="text.secondary">
          Actualizando...
        </Typography>
      ) : error ? (
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      ) : data.last_update ? (
        <>
          <Typography variant="caption" color="text.secondary">
            Última actualización:
          </Typography>
          <Typography variant="caption" color="primary" fontWeight={600}>
            {getRelativeTime(data?.last_update)}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ visibility: 'hidden' }}
          >
            {data?.last_update}
          </Typography>
        </>
      ) : null}
    </Box>
  );
};

// Utilidad para mostrar tiempo relativo
function getRelativeTime(dateString) {
  if (!dateString) return '';
  // Asegura formato ISO para Date
  const isoString = dateString.replace(' ', 'T') + 'Z';
  const date = new Date(isoString);
  const now = new Date();
  const diffMs = now - date;
  const diffSec = Math.floor(diffMs / 1000);
  if (diffSec < 60) return `hace ${diffSec} segundo${diffSec !== 1 ? 's' : ''}`;
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `hace ${diffMin} minuto${diffMin !== 1 ? 's' : ''}`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `hace ${diffHr} hora${diffHr !== 1 ? 's' : ''}`;
  const diffDay = Math.floor(diffHr / 24);
  return `hace ${diffDay} día${diffDay !== 1 ? 's' : ''}`;
}

export default LastUpdated;
